import { observer } from 'mobx-react-lite';
import { PopupStore } from '../../popup.store';

export const PaymentFailure = observer<{ popupStore: PopupStore; styles: { [key: string]: string } }>(({ popupStore, styles }) => {
  return (
    <>
      <h4 className="cust-my-4">
        <i className="text-warning icon-fix-errors  h1 cust-pr-1" />
        Payment has an issue
      </h4>

      <h4 className="cust-my-4">Please contact support</h4>
    </>
  );
});